import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { createBrowserHistory } from "history";

const Breadcrumb = (props) => {
  const [searchHistory, setSearchHistory] = useState([
    {
      label: "Home",
      path: "/",
    },
  ]);

  const history = createBrowserHistory();
  let location = useLocation();

  useEffect(() => {
    const localHistory = JSON.parse(localStorage.getItem("localHistory"));

    const pathnameParts = location.pathname.split("/");
    const lastPathnamePart = pathnameParts[pathnameParts.length - 1];
    const capitalizedLabel = capitalizeFirstLetter(
      lastPathnamePart.replace(/_/g, " ")
    );
    const updatedSearchHistory = [
      ...(Array.isArray(localHistory)
        ? localHistory.slice(0, pathnameParts.length - 1)
        : searchHistory.slice(0, pathnameParts.length - 1)),
      {
        label: capitalizedLabel,
        path: location.pathname + location.search,
      },
    ];
    updatedSearchHistory[0] = {
      label: "Home",
      path: "/",
    };
    setSearchHistory(updatedSearchHistory);
    localStorage.setItem("localHistory", JSON.stringify(updatedSearchHistory));
  }, [location.pathname]);

  function isLast(index) {
    return index === searchHistory.length - 1;
  }

  function isLastButOne(index) {
    return index === searchHistory.length - 2;
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return (
    <>
      <div className="row">
        <nav className="breadcrumb-container pl-2" aria-label="breadcrumb">
          <ol className="breadcrumb" data-element="breadcrumb">
            <>
              {searchHistory.map((search, index) => (
                <React.Fragment key={index}>
                  {
                    <>
                      {isLast(index) ? (
                        <li className={"breadcrumb-item active"}>
                          <a
                            style={{
                              textDecoration: "none",
                            }}
                            href={search.path}
                            data-element={search.label}
                          >
                            {search.label}
                          </a>
                        </li>
                      ) : isLastButOne(index) && history.length > 2 ? (
                        <li
                          onClick={() => history.goBack()}
                          className={"breadcrumb-item "}
                        >
                          <span
                            className="breadCrumbCustom"
                            style={{ cursor: "pointer" }}
                          >
                            {search.label}
                          </span>
                          <span className="separator">/</span>
                        </li>
                      ) : history.length <= 2 ? (
                        <li className={"breadcrumb-item "}>
                          <Link to={"/home"}>{search.label}</Link>
                          <span className="separator">/</span>
                        </li>
                      ) : (
                        <li className={"breadcrumb-item "}>
                          {search.path.startsWith("http") ? (
                            <a href={search.path}>{search.label}</a>
                          ) : (
                            <Link to={search.path}>{search.label}</Link>
                          )}
                          <span className="separator">/</span>
                        </li>
                      )}
                    </>
                  }
                </React.Fragment>
              ))}
            </>
          </ol>
        </nav>
      </div>
    </>
  );
};

export default Breadcrumb;
